import { Icon, Text } from '@kanda-libs/ks-design-library';

import Container from './PaymentOptions-container';

import { CLASS_NAMES } from '../../Desktop-constants';

const ViewComponent = () => (
  <Container>
    {({ options }) =>
      options.length > 0 ? (
        <div className={CLASS_NAMES.card}>
          {options.map(({ icon, title, subtitle }) => (
            <div key={title} className={CLASS_NAMES.panel}>
              <div className="flex flex-col gap-y-2">
                <div className="flex flex-row">
                  <Icon
                    icon={icon}
                    size={20}
                    className="mr-3 my-auto"
                    stroke="neutral-700"
                  />
                  <Text
                    text={title}
                    className="text-14-22-em text-neutral-700"
                  />
                </div>
                {subtitle && (
                  <Text
                    text={subtitle}
                    className="text-12-18 text-neutral-600"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      ) : null
    }
  </Container>
);

ViewComponent.displayName = 'PaymentMethods-Desktop-PaymentOptions-view';

export default ViewComponent;
